module.exports = __webpack_public_path__ + "img/cover.051a17ff.jpg";